export enum RnD { None, Internal, External }

export enum Role { PrecureAdmin ="PrecureAdmin", SolutionOwner = "SolutionOwner", LocalCoordinator = "LocalCoordinator", Partner = "Partner" }

export enum Anonymity { Known, Unknown }

export enum DeviceType { Elbow, Back }

export enum Stage { Preparation, NotStarted, Started, Complete } 

export enum StorageRegion { Testing, EU, US }

export enum GroupByOverview {
  Organization = "Organization",
  Workspace = "Workspace",
  // Project = "Project",
}

export enum Metric {
  MLI,
  Pain,
}

export enum Industry
{
  Other,
  AgricultureForestryAndFishing,
  MiningAndQuarrying,
  Manufacturing,
  ElectricityGasAndAirConditioningSupply,
  WaterSupplyAndWasteManagement,
  Construction,
  WholesaleAndRetailTrade,
  TransportationAndStorage,
  AccommodationAndFoodServices,
  InformationAndCommunication,
  FinancialAndInsuranceActivities,
  RealEstateActivities,
  ProfessionalScientificAndTechnicalActivities,
  AdministrativeAndSupportServices,
  PublicAdministrationAndDefense,
  Education,
  HealthAndSocialWorkActivities,
  ArtsEntertainmentAndRecreation,
  OtherServiceActivities,
  ActivitiesOfHouseholdsAsEmployers,
    ActivitiesOfExtraterritorialOrganizations
}

export type Severity = "error" | "success" | "info" | "warning" | undefined;

export enum ErrorCodes {
  InternalServerError = "InternalServerError",
  ProductNotFound = "ProductNotFound",
  ProductTypeNotFound = "ProductTypeNotFound",
  EmptyProductTypeList = "EmptyProductTypeList",
  EmptyProductTypesOnPlan = "EmptyProductTypesOnPlan",
  PlanNotFound = "PlanNotFound",
  MissingSerialField = "MissingSerialField",
  ProductAlreadyExist = "ProductAlreadyExist",
  NoDeletedRows = "NoDeletedRows",
  ManyDeletedRows = "ManyDeletedRows",
  EmptyPlannedProductsOnPlan = "EmptyPlannedProductsOnPlan",
}
